import {IApplicationState} from '../../../../../../types/types';
import { TTabsModelState } from '../../../../../../store/model/tabs/types';

export const getTabs = (
    state: IApplicationState,
): TTabsModelState => {
    return state.model.tabs;
};
